import { S3Attachment, UserCode } from '@anb/ng-forms';
import { SnackBarAlert } from '@anb/ng-ui';
import {
  AfschotmeldingDto,
  AfschotmeldingGegevensDier,
  AfschotplanDetails,
  DatumEnTijdDetails,
  GegevensAfschot,
  LabelDto,
  OpmerkingDto,
} from '@core/api/proxy';
import { createAction } from '@ngrx/store';

export const RedirectToFrontOffice = createAction('[Dossier] Redirect');

export const GetUserCodes = createAction('[UserCodes] Get Codes');
export const GetUserCodesSuccess = createAction('[UserCodes] Get Codes : Successful', (codes: UserCode[]) => ({ codes }));
export const GetUserCodesFailed = createAction('[UserCodes] Get Codes : Failed', (error: string) => ({ error }));

export const UpdateDatumEnTijd = createAction('[DatumEnTijd] : Update datumEnTijd', (datumEnTijd: DatumEnTijdDetails) => datumEnTijd);
export const UpdateDatumEnTijdSuccess = createAction('[DatumEnTijd] : Update datumEnTijd success');
export const UpdateDatumEnTijdFailed = createAction('[DatumEnTijd] : Update datumEnTijd failed');

export const UpdateVolgNummer = createAction('[VolgNummer] : Update volgNummer', (afschotplanDetails: AfschotplanDetails) => afschotplanDetails);
export const UpdateVolgNummerSuccess = createAction('[VolgNummer] : Update volgNummer success');
export const UpdateVolgNummerFailed = createAction('[VolgNummer] : Update volgNummer failed');

export const UpdateLocatie = createAction('[Locatie] : Update locatie', (locaties: any[]) => ({ locaties }));
export const UpdateLocatieSuccess = createAction('[Locatie] : Update locatie success');
export const UpdateLocatieFailed = createAction('[Locatie] : Update locatie failed', (error: string) => ({ error }));

export const UpdateGegevensDier = createAction('[GegevensDier] : Update gegevensDier', (gegevensDier: AfschotmeldingGegevensDier) => ({
  gegevensDier,
}));
export const UpdateGegevensDierSuccess = createAction('[GegevensDier] : Update gegevensDier success');
export const UpdateGegevensDierFailed = createAction('[GegevensDier] : Update gegevensDier failed');

export const UpdateGegevensAfschot = createAction('[GegevensAfschot] : Update gegevensAfschot', (gegevensAfschot: GegevensAfschot) => ({
  gegevensAfschot,
}));
export const UpdateGegevensAfschotSuccess = createAction('[GegevensAfschot] : Update gegevensAfschot success');
export const UpdateGegevensAfschotFailed = createAction('[GegevensAfschot] : Update gegevensAfschot failed');

export const UpdateOpmerkingen = createAction('[UpdateOpmerkingen] : Update opmerkingen', (opmerkingen: string) => ({
  opmerkingen,
}));
export const UpdateOpmerkingenSuccess = createAction('[UpdateOpmerkingen] : Update opmerkingen success');
export const UpdateOpmerkingenFailed = createAction('[UpdateOpmerkingen] : Update opmerkingen failed');

export const GetLabels = createAction('[GetLabel] : Get labels', (afschotNummer: string) => ({
  afschotNummer,
}));
export const GetLabelsSuccess = createAction('[GetLabel] :  Get labels success', (labels: Array<LabelDto>) => ({ labels }));
export const GetLabelsFailed = createAction('[GetLabel] :  Get labels failed');

export const AddComment = createAction('[AddComment] : Add comment', (inhoud: string) => ({
  inhoud,
}));
export const AddCommentSuccess = createAction('[AddComment] : Add comment success', (inhoud: string) => ({ inhoud }));
export const AddCommentFailed = createAction('[AddComment] : Add comment failed');

export const GetComments = createAction('[GetComments] : Get comments');
export const GetCommentsSuccess = createAction('[GetComments] : Get comments success', (comments: OpmerkingDto[]) => ({ comments }));
export const GetCommentsFailed = createAction('[GetComments] : Get comments failed');

export const OpslaanForms = createAction('[OpslaanForms] : OpslaanForms');
export const ShowSuccessSnackbar = createAction('[SuccessSnackbar] : Success snackbar show', (success: SnackBarAlert) => ({ success }));

export const AddBijlage = createAction('[AddBijlage] : Add bijlage', (bijlage: S3Attachment) => ({
  bijlage,
}));
export const AddBijlageSuccess = createAction('[AddBijlage] : Add bijlage success', (bijlage: S3Attachment) => ({
  bijlage,
}));
export const AddBijlageFailed = createAction('[AddBijlage] : Add bijlage failed');

export const IndienenAfschotmelding = createAction('[Indienen] : Indienen Afschotmelding');
export const IndienenAfschotmeldingSuccess = createAction('[Indienen] : Indienen Afschotmelding success');
export const IndienenAfschotmeldingFailed = createAction('[Indienen] : Indienen Afschotmelding failed');
